import script from "./Step3Registration.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Step3Registration.vue?vue&type=script&setup=true&lang=ts"
export * from "./Step3Registration.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Step3Registration.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__